export const cityRanking = [
  '基隆市',
  '台北市',
  '北市公有',
  '新北市',
  '桃園市',
  '新竹市',
  '新竹縣',
  '苗栗市',
  '苗栗縣',
  '台中市',
  '彰化縣',
  '雲林縣',
  '南投市',
  '南投縣',
  '嘉義市',
  '嘉義縣',
  '台南市',
  '高雄市',
  '屏東縣',
  '宜蘭市',
  '宜蘭縣',
  '花蓮市',
  '花蓮縣',
  '台東縣',
  '澎湖縣',
  '金門縣',
  '連江縣'
];

const cityRankingOriginal = [
  'keelung_city',
  'pi_keelung_city',
  'taipei_city',
  'pi_taipei_city',
  'new_taipei_city',
  'pi_new_taipei_city',
  'taoyuan_city',
  'pi_taoyuan_city',
  'hsinchu_county',
  'pi_hsinchu_county',
  'hsinchu_city',
  'pi_hsinchu_city',
  'miaoli_county',
  'miaoli_city',
  'pi_miaoli_city',
  'taichung_city',
  'pi_taichung_city',
  'nantou_county',
  'changhua_county',
  'pi_changhua_county',
  'yunlin_county',
  'chiayi_city',
  'pi_chiayi_city',
  'chiayi_county',
  'tainan_city',
  'pi_tainan_city',
  'kaohsiung_city',
  'pi_kaohsiung_city',
  'pingtung_county',
  'yilan_city',
  'yilan_county',
  'pi_yilan_county',
  'hualien_city',
  'hualien_county',
  'pi_hualien_county',
  'taitung_county',
  'pi_taitung_county',
  'penghu_county',
  'pi_penghu_county',
  'kinmen_county',
  'lienchiang_county',
  'casterly_rock_city',
  'atlantis_city',
  'winterfell_city'
];


export const compare = (a, b) => {
  return ranking(a) - ranking(b);
};

export const ranking = city => {
  return cityRanking.indexOf(city);
};

// use for get city list from api and sorting

export const compareOriginal = (a,b)=>{
  return rankingOriginal(a) - rankingOriginal(b)
}

export const rankingOriginal = city => {
  return cityRankingOriginal.indexOf(city)
}